import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { useSelector } from 'react-redux';


function RequireAuth() {
	const { isLoggedIn, token } = useAuth();
	const location = useLocation();
	const { mainMenu } = useSelector((state) => state.activeAccount);


	const validRoutes = Object.keys(mainMenu || {})
		.filter((key) => mainMenu[key] === 1)
		.map((key) => key.replace('FRONT:', ''));


	// const isValidRoute = validRoutes.includes(location.pathname);

	const isValidRoute = validRoutes.some((route) => {
		// Exact match
		if (location.pathname === route) return true;
		// Dynamic route
		if (route.includes(':')) {
			const baseRoute = route.split('/:')[0];
			return location.pathname.startsWith(baseRoute + '/');
		}
		return false;
	});

	if (!isLoggedIn || !token) {
		return <Navigate to='/login' state={{ from: location }} replace />;
	}

	if (!isValidRoute) {
		return <Navigate to='/not-found' replace />;
	}

	return <Outlet />;


	// return isLoggedIn && token ? (
	// 	<Outlet />
	// ) : (
	// 	<Navigate to='/login' state={{ from: location }} replace />
	// );
}

export default RequireAuth;
